<template>
  <div style="width: 100%">
    <!-- Div contenente lo sfondo (fisso) di questa videata -->
    <div class="sfondo" style="position: fixed; left: 0px; top: 0px"></div>
    <!-- Menu di selezione -->
    <v-row align="center" justify="end" v-if="menu_visible">
      <v-col cols="0" md="6"> </v-col>
      <v-col cols="7" md="6" lg="5">
        <!-- Menu di selezione -->
        <Menu
          :autocontrolli_allowed="autocontrolli_allowed"
          :causali_allowed="causali_allowed"
          :contenitori_allowed="contenitori_allowed"
          @click_autocontrolli="clickAutocontrolli"
          @click_causali_fermo="clickCausaliFermo"
          @click_contenitori="clickContenitori"
          @click_ordini="clickOrdini"
          @click_pezzi="clickPezzi"
          @click_pezzi_insit="clickPezziInsit"
          @click_scarti="clickScarti"
          @click_tempi="clickTempi"
          @click_tempi_squadra="clickTempiSquadra"
          @click_tracciabilita="clickTracciabilita"
          :ordini_allowed="ordini_allowed"
          :pezzi_allowed="pezzi_allowed"
          :pezzi_insit_allowed="pezzi_insit_allowed"
          :rotta_back="rotta_back"
          :scarti_allowed="scarti_allowed"
          :tempi_allowed="tempi_allowed"
          :tempi_squadra_allowed="tempi_squadra_allowed"
          :tracciabilita_allowed="tracciabilita_allowed"
          style="display: inline-block; width: 100%; margin-top: 40px"
        />
      </v-col>
      <v-col cols="1"> </v-col>
    </v-row>

    <TabellaPezzi
      @click_chiudi="(pezzi_visible = false), (menu_visible = true)"
      v-if="pezzi_visible"
    />
    <TabellaPezziInsit
      @click_chiudi="(pezzi_insit_visible = false), (menu_visible = true)"
      v-if="pezzi_insit_visible"
    />
    <TabellaTempi
      @click_chiudi="(tempi_visible = false), (menu_visible = true)"
      v-if="tempi_visible"
    />
    <TabellaTempiSquadra
      @click_chiudi="(tempi_squadra_visible = false), (menu_visible = true)"
      v-if="tempi_squadra_visible"
    />
    <TabellaScarti
      @click_chiudi="(scarti_visible = false), (menu_visible = true)"
      v-if="scarti_visible"
      :visible="scarti_visible"
    />
    <TabellaFermi
      @click_chiudi="(causali_fermo_visible = false), (menu_visible = true)"
      v-if="causali_fermo_visible"
      :visible="causali_fermo_visible"
    />

    <ContenitoriCristal
      @click_chiudi="(contenitori_visible = false), (menu_visible = true)"
      v-if="contenitori_visible"
      :visible="contenitori_visible"
    />

    <ControlloQualitaCristal
      @click_chiudi="(autocontrolli_visible = false), (menu_visible = true)"
      v-if="autocontrolli_visible"
      :visible="autocontrolli_visible"
    />

    <TabellaOrdini
      @click_chiudi="(ordini_visible = false), (menu_visible = true)"
      :filtri_visible="true"
      v-if="ordini_visible"
      :visible="ordini_visible"
    />

    <RistampaSeriali
      :close_icon="'mdi-keyboard-backspace'"
      style="padding: 20px"
      :filtri_visible="true"
      @chiudi="(tracciabilita_visible = false), (menu_visible = true)"
      v-if="tracciabilita_visible"
    />
    <v-overlay :value="caricamento_dati">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import ContenitoriCristal from "@/components/PRODUCTION/Avanzamento/ContenitoriCristal.vue";
import ControlloQualitaCristal from "@/components/PRODUCTION/Avanzamento/ControlloQualitaCristal.vue";
import Menu from "@/components/PRODUCTION/Avanzamento/Menu.vue";
import RistampaSeriali from "@/components/PRODUCTION/ProduzioneInsit/RistampaSeriali";
import TabellaFermi from "@/components/PRODUCTION/Avanzamento/TabellaFermi.vue";
import TabellaPezzi from "@/components/PRODUCTION/Avanzamento/TabellaPezzi.vue";
import TabellaPezziInsit from "@/components/PRODUCTION/Avanzamento/TabellaPezziInsit.vue";
import TabellaScarti from "@/components/PRODUCTION/Avanzamento/TabellaScarti.vue";
import TabellaTempi from "@/components/PRODUCTION/Avanzamento/TabellaTempi.vue";
import TabellaTempiSquadra from "@/components/PRODUCTION/Avanzamento/TabellaTempiSquadra.vue";
import TabellaOrdini from "../Ordini/TabellaOrdini.vue";
export default {
  name: "Avanzamento",
  components: {
    ContenitoriCristal,
    ControlloQualitaCristal,
    Menu,
    RistampaSeriali,
    TabellaFermi,
    TabellaPezzi,
    TabellaPezziInsit,
    TabellaScarti,
    TabellaTempi,
    TabellaTempiSquadra,
    TabellaOrdini,
  },
  props: {
    autocontrolli_allowed: { type: Boolean, default: true },
    causali_allowed: { type: Boolean, default: true },
    contenitori_allowed: { type: Boolean, default: true },
    pezzi_allowed: { type: Boolean, default: true },
    pezzi_insit_allowed: { type: Boolean, default: false },
    rotta_back: { type: String, default: "/home/production" },
    scarti_allowed: { type: Boolean, default: true },
    tempi_allowed: { type: Boolean, default: true },
    tempi_squadra_allowed: { type: Boolean, default: true },
    tracciabilita_allowed: { type: Boolean, default: true },
    ordini_allowed: { type: Boolean, default: true },
  },
  data() {
    return {
      // Variabili d'appoggio
      caricamento_dati: false,

      // Modal
      autocontrolli_visible: false,
      causali_fermo_visible: false,
      contenitori_visible: false,
      pezzi_visible: false,
      pezzi_insit_visible: false,
      scarti_visible: false,
      tempi_visible: false,
      tempi_squadra_visible: false,
      ordini_visible: false,
      tracciabilita_visible: false,
      menu_visible: true,

      // Array
    };
  },
  methods: {
    clickAutocontrolli() {
      this.autocontrolli_visible = true;
      this.menu_visible = false;
    },
    clickCausaliFermo() {
      this.causali_fermo_visible = true;
      this.menu_visible = false;
    },
    clickContenitori() {
      this.contenitori_visible = true;
      this.menu_visible = false;
    },
    clickPezzi() {
      this.pezzi_visible = true;
      this.menu_visible = false;
    },
    clickPezziInsit() {
      this.pezzi_insit_visible = true;
      this.menu_visible = false;
    },
    clickScarti() {
      this.scarti_visible = true;
      this.menu_visible = false;
    },
    clickTempi() {
      this.tempi_visible = true;
      this.menu_visible = false;
    },
    clickTempiSquadra() {
      this.tempi_squadra_visible = true;
      this.menu_visible = false;
    },
    clickOrdini() {
      this.ordini_visible = true;
      this.menu_visible = false;
    },
    clickTracciabilita() {
      this.tracciabilita_visible = true;
      this.menu_visible = false;
    },
  },
  mounted() {},
};
</script>
<style scoped>
.sfondo {
  width: 100vw !important;
  background-image: url("../../../assets/Ind.jpg");

  background-color: #cccccc; /* Used if the image is unavailable */
  height: 100vh !important; /* You must set a specified height */
  background-position: cover; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
</style>